export default __webpack_public_path__ + "static/media/stop.df1f2b03.svg";